/* import __COLOCATED_TEMPLATE__ from './date-page.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './date-page.module.scss';

@classic
@classNames('date-page', styles.component)
export default class RequestDatePage extends Component {}
